{
  "page": {
    "description": "Permisos, vacaciones, licencias y descansos médicos: esos días no cuentan como falta.",
    "new": "Registrar ausencia",
    "caption": "Ausencias"
  },
  "types": {
    "PERMISSION": "Permiso",
    "VACATION": "Vacaciones",
    "LICENSE": "Licencia",
    "MEDICAL_LEAVE": "Descanso médico",
    "partial": "{type} por horas"
  },
  "status": {
    "ACTIVE": "Activa",
    "CANCELLED": "Cancelada"
  },
  "format": {
    "range": "{from} al {to}",
    "hours": "{day} · {range}"
  },
  "filters": {
    "legend": "Filtros de ausencias",
    "fromDay": "Desde",
    "toDay": "Hasta",
    "worker": "Trabajador",
    "allWorkers": "Todos los trabajadores",
    "site": "Sede",
    "allSites": "Todas las sedes",
    "type": "Tipo",
    "allTypes": "Todos los tipos",
    "statusLabel": "Estado",
    "status": {
      "ACTIVE": "Activas",
      "CANCELLED": "Canceladas",
      "ALL": "Todas"
    },
    "rangeInverted": "La fecha final no puede ser anterior a la inicial."
  },
  "columns": {
    "worker": "Trabajador",
    "type": "Tipo",
    "from": "Desde",
    "to": "Hasta / Horario",
    "note": "Nota",
    "status": "Estado",
    "source": "Origen",
    "actions": "Acciones"
  },
  "table": {
    "noNote": "—",
    "cancel": "Cancelar",
    "cancelLabel": "Cancelar la ausencia de {worker} ({type})",
    "cancelReason": "Motivo: {reason}"
  },
  "form": {
    "title": "Registrar ausencia",
    "description": "Los días de la ausencia no cuentan como falta, aunque tengan turno asignado.",
    "worker": "Trabajador",
    "workerPlaceholder": "Elige un trabajador",
    "workerSearch": "Busca por nombre o código",
    "type": "Tipo",
    "mode": "Duración",
    "modes": {
      "FULL_DAY": "Todo el día",
      "HOURS": "Por horas"
    },
    "startDay": "Desde",
    "endDay": "Hasta",
    "day": "Día",
    "startTime": "Desde (hora)",
    "endTime": "Hasta (hora)",
    "hoursHelp": "Un permiso por horas es de un solo día. La tardanza se cuenta desde el fin del permiso.",
    "note": "Nota (opcional)",
    "noteCount": "{count}/{max}",
    "rangeSummary": "Del {from} al {to}, días calendario.",
    "submit": "Registrar ausencia",
    "errors": {
      "worker_id": "Elige un trabajador.",
      "type": "Elige el tipo de ausencia.",
      "start_day": "Elige la fecha de inicio.",
      "end_day": "Elige la fecha final.",
      "start_time": "Elige la hora de inicio.",
      "end_time": "Elige la hora de fin.",
      "note": "La nota puede tener hasta 300 caracteres."
    }
  },
  "cancel": {
    "title": "Cancelar ausencia",
    "description": "{type} de {worker} · {range}",
    "notice": "La ausencia no se borra: queda en el historial como cancelada y esos días vuelven a evaluarse normalmente.",
    "reason": "Motivo",
    "reasonRequired": "Escribe el motivo (hasta 300 caracteres).",
    "confirm": "Cancelar ausencia"
  },
  "toast": {
    "created": "Registramos la ausencia de {worker} ({type})",
    "cancelled": "Cancelamos la ausencia de {worker} ({type})"
  },
  "empty": {
    "title": "Aún no hay ausencias",
    "description": "Registra vacaciones, permisos, licencias o descansos médicos para que no cuenten como falta."
  },
  "noResults": {
    "title": "No hay ausencias con esos filtros",
    "description": "Cambia los filtros para ver otras ausencias."
  },
  "error": {
    "title": "No pudimos cargar las ausencias"
  },
  "managed": {
    "locked": "{system}: no se puede cancelar aquí."
  }
}
